<template>
  <div class="wrapper">
    <h5 class="header-title">Niveau de bruit</h5>
    <div class="graph-row">
      <img
        class="bars"
        :src="svgUrl"
        alt="Graphique en barres colorées montrant le niveau de bruit"
      />
      {{ description }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

import NOISE_LEVEL_LOW from "@/assets/img/tweet_noise_level/low.svg";
import NOISE_LEVEL_MEDIUM_LOW from "@/assets/img/tweet_noise_level/medium_low.svg";
import NOISE_LEVEL_MEDIUM_HIGH from "@/assets/img/tweet_noise_level/medium_high.svg";
import NOISE_LEVEL_HIGH from "@/assets/img/tweet_noise_level/high.svg";

const props = defineProps({ level: { type: Number, required: true } });

const svgUrl = computed(
  () =>
    [
      NOISE_LEVEL_LOW,
      NOISE_LEVEL_MEDIUM_LOW,
      NOISE_LEVEL_MEDIUM_HIGH,
      NOISE_LEVEL_HIGH,
    ][props.level]
);

const description = computed(
  () =>
    [
      "Ce dossier fait partie des dossiers législatif peu discutés.",
      "Ce dossier fait partie des dossiers législatif faiblement discutés.",
      "Ce dossier fait partie des dossiers législatif très discutés.",
      "Ce dossier est très discuté, il fait partie des dossiers législatif chauds.",
    ][props.level]
);
</script>

<style scoped lang="scss">
.wrapper {
  color: var(--clr-s8);
}
.header-title {
  text-align: center;
}

.graph-row {
  display: flex;
  align-items: center;
  flex-grow: 1;
  gap: 8px;
}
.bars {
  width: 125px;
}
</style>
